// extracted by mini-css-extract-plugin
module.exports = {"slide":"TabPrepaid_slide_3uLNH","slide-reverse":"TabPrepaid_slide-reverse_2UI0n","btnTop":"TabPrepaid_btnTop_3nlYy"};